/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BrokerActivityFeedTypeEnum;

(function (BrokerActivityFeedTypeEnum) {
  BrokerActivityFeedTypeEnum["DECLINED"] = "declined";
  BrokerActivityFeedTypeEnum["APPROVED"] = "approved";
  BrokerActivityFeedTypeEnum["ADJUSTED"] = "adjusted";
  BrokerActivityFeedTypeEnum["CREATE_OR_UPDATE"] = "create_or_update";
})(BrokerActivityFeedTypeEnum || (BrokerActivityFeedTypeEnum = {}));